module.exports = __webpack_public_path__ + "static/media/liam_horne.a38ad4b9.jpeg";